export default __webpack_public_path__ + "media/images/icons/twitter-87682341d07c5f155f20c82e111fd3ae.svg";